var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSheets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_3724",
    "data-name": "Grupo 3724",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84.222,
    height: 115.597,
    viewBox: "0 0 84.222 115.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff005d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1591",
    "data-name": "Ret\\xE2ngulo 1591",
    width: 84.222,
    height: 115.597,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3723",
    "data-name": "Grupo 3723",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1114",
    "data-name": "Caminho 1114",
    d: "M127.976,2.724V20.517h-1.009V19.508a1.01,1.01,0,0,1,1.009,1.009h-1.009V19.508h17.275a2.224,2.224,0,0,1,0,4.447H126.967a3.438,3.438,0,0,1-3.438-3.438V2.724a2.224,2.224,0,1,1,4.447,0Z",
    transform: "translate(-62.491 -0.253)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1115",
    "data-name": "Caminho 1115",
    d: "M87.5,2.724V4.947H43.913v-1.5h1.5a1.5,1.5,0,0,1-1.5,1.5v-1.5h1.5V92.1h-1.5V90.6a1.5,1.5,0,0,1,1.5,1.5h-1.5V90.6h57.845v1.5h-1.5a1.5,1.5,0,0,1,1.5-1.5v1.5h-1.5V18.953L85.914,4.278,87.5,2.724v0l1.59-1.554L104.7,17.141V92.1a2.944,2.944,0,0,1-2.943,2.943H43.913A2.943,2.943,0,0,1,40.97,92.1V3.443A2.943,2.943,0,0,1,43.913.5H88.441l.654.67Z",
    transform: "translate(-20.726 -0.253)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1116",
    "data-name": "Caminho 1116",
    d: "M32.837,24.181h-9.4v-1.5h1.5a1.505,1.505,0,0,1-1.5,1.5v-1.5h1.5v88.66h-1.5v-1.5a1.5,1.5,0,0,1,1.5,1.5h-1.5v-1.5H81.285v1.5h-1.5a1.5,1.5,0,0,1,1.5-1.5v1.5h-1.5v-8.784a2.224,2.224,0,1,1,4.447,0v8.784a2.943,2.943,0,0,1-2.942,2.943H23.439a2.943,2.943,0,0,1-2.942-2.943V22.677a2.943,2.943,0,0,1,2.943-2.943h9.4a2.224,2.224,0,0,1,0,4.447Z",
    transform: "translate(-10.369 -9.983)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1117",
    "data-name": "Caminho 1117",
    d: "M12.84,46.55h-9.4v-1.5h1.5a1.5,1.5,0,0,1-1.5,1.5v-1.5h1.5v88.66h-1.5v-1.5a1.5,1.5,0,0,1,1.5,1.5h-1.5v-1.5H61.288v1.5h-1.5a1.5,1.5,0,0,1,1.5-1.5v1.5h-1.5v-8.784a2.224,2.224,0,1,1,4.447,0v8.784a2.944,2.944,0,0,1-2.943,2.943H3.443A2.944,2.944,0,0,1,.5,133.706V45.046A2.943,2.943,0,0,1,3.443,42.1h9.4a2.224,2.224,0,1,1,0,4.447Z",
    transform: "translate(-0.253 -21.299)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1118",
    "data-name": "Caminho 1118",
    d: "M67.12,69.3h35.671a2.224,2.224,0,1,1,0,4.447H67.12a2.224,2.224,0,0,1,0-4.447",
    transform: "translate(-32.83 -35.058)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1119",
    "data-name": "Caminho 1119",
    d: "M67.12,99.3h35.671a2.224,2.224,0,1,1,0,4.447H67.12a2.224,2.224,0,0,1,0-4.447",
    transform: "translate(-32.83 -50.232)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1120",
    "data-name": "Caminho 1120",
    d: "M67.12,129.291h35.671a2.224,2.224,0,1,1,0,4.447H67.12a2.224,2.224,0,0,1,0-4.447",
    transform: "translate(-32.83 -65.406)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSheets);
export default __webpack_public_path__ + "static/media/icon-sheets.cdb066ae27237cea493bd6be976ef6f2.svg";
export { ForwardRef as ReactComponent };